var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"pt-1 mt-0",attrs:{"items":_vm.patientTimezoneList,"dense":_vm.isDense,"required":"","rules":_vm.patientTimezoneRules,"outlined":_vm.isOutlined,"item-value":_vm.timezone,"label":_vm.label},model:{value:(_vm.timezone),callback:function ($$v) {_vm.timezone=$$v},expression:"timezone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }